import React from 'react';
import { Box, Flex, Button, Text, Link as ChakraLink } from '@chakra-ui/react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <Box bg="teal.500" px={4} py={3}>
      <Flex maxW="1200px" mx="auto" justify="space-between" align="center">
        <ChakraLink as={RouterLink} to="/">
          <Text fontSize="xl" fontWeight="bold" color="white">
            URL Shortener
          </Text>
        </ChakraLink>
        <Flex>
          {!isAuthenticated ? (
            <>
              <Button as={RouterLink} to="/login" colorScheme="whiteAlpha" mr={4}>
                Login
              </Button>
              <Button as={RouterLink} to="/register" colorScheme="whiteAlpha">
                Register
              </Button>
            </>
          ) : (
            <>
              <Button as={RouterLink} to="/dashboard" colorScheme="whiteAlpha" mr={4}>
                Dashboard
              </Button>
              <Button onClick={handleLogout} colorScheme="whiteAlpha">
                Logout
              </Button>
            </>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default Navbar;
